<template>
    <swiper
        :slides-per-view="1"
        :space-between="0"
        :navigation="navigation"        
        :class="class"
        class="w-full h-full"
        @slideChange="slideChange"
    >
        <template v-for="(image, index) in gallery" :key="index">
            <swiper-slide 
                v-if="image.orientation != 'portrait'"                
                class="bg-cover"
                :class="imageSlideClass"
                :style="styleCss(image)"
                >                    
            </swiper-slide>        
        </template>
    </swiper>
    
    <div class="absolute bottom-0 z-50" :class="controlsRight ? 'right-0' : 'left-0'">
        <div class="flex items-center">
            <div class="text-lg font-bold text-white px-4 lg:px-8">
                {{ index }} / {{ gallery.length }}
            </div>
            <div :class="'swiper-prev-'+random" class="w-12 h-12 bg-white text-xl flex items-center justify-center text-center hover:bg-yellow transition-colors duration-300 cursor-pointer">
                <span class="icon-chevron-left"></span>
            </div>
            <div :class="'swiper-next-'+random" class="w-12 h-12 bg-white text-xl flex items-center justify-center text-center hover:bg-yellow transition-colors duration-300 cursor-pointer">
                <span class="icon-chevron-right"></span>
            </div>
            <div class="bg-white bg-opacity-70 h-12 md:min-w-[250px] flex items-center justify-center" v-if="gallery.length == labels.length">
                <span class="font-light text-lg px-8" v-html="labels[index-1]"></span>
            </div>
        </div>
    </div>
</template>

<script>
import SwiperCore, { Navigation, Lazy } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/vue';
 
SwiperCore.use([Navigation, Lazy]);

export default {

    props: [
        'gallery',
        'imageSlideClass',
        'class'
    ],

    components: {
        Swiper,
        SwiperSlide,
    },

    computed: {
        controlsRight() {
            if (this.class == 'left') {
                return true
            }
            return false
        },
        labels() {
            let labels = [];
            this.gallery.forEach((image) => {
                if ('alt' in image) {
                    labels.push(image.alt)
                }
            })
            return labels
        }
    },

    data() {
        return {
            'index': 1,
            'random': Math.random().toString(36).substring(2, 15),
            'navigation': {
                nextEl: '',
                prevEl: ''
            }
        }
    },

    mounted() {
        this.navigation.nextEl = '.swiper-next-'+this.random
        this.navigation.prevEl = '.swiper-prev-'+this.random
    },

    methods: {
        styleCss(image) {
            let style = 'background-image: url("'+image.large+'");'
            if (image.focus_css) {
                style += 'background-position: '+image.focus_css+';'
            }
            return style
        },
        slideChange(swiper) {
            this.index = swiper.activeIndex + 1
        }
    }

};
</script>